class HeroBanner {
    constructor(element) {
        this.element = element;
        this.heroWrapper = element.querySelector('.hero-banner__wrapper');
        this.heroWrapperMobileOffset = 28;
        this.heroContent = element.querySelector('.hero-banner__content');
        this.heroSlider = element.querySelector('.hero-banner-slider');

        this.updateWrapperPadding();
        if (this.heroSlider) this.repositionSliderNavi();

        window.addEventListener('resize', () => {
            this.updateWrapperPadding();
            if (this.heroSlider) this.repositionSliderNavi();
        });

        document.addEventListener('heroBannerIsMounted', () => {
            if (this.heroSlider) this.repositionSliderNavi();
        });
    }

    updateWrapperPadding() {
        const height = this.heroContent.offsetHeight;
        if (window.innerWidth > 768) {
            this.heroWrapper.style.height = `${height / 2}px`;
        } else {
            this.heroWrapper.style.height = `${height - this.heroWrapperMobileOffset}px`;
        }
    }

    repositionSliderNavi() {
        let topOffset;
        const heroContentRect = this.heroContent.getBoundingClientRect();
        const heroContentSliderNavi = this.element.querySelector('.slider__arrows');
        const elementStyles = getComputedStyle(this.heroContent);
        const heroContentPaddingTop = elementStyles.getPropertyValue('--hero-content-padding-top').trim();
        const heroContentPaddingRight = elementStyles.getPropertyValue('--hero-content-padding-right').trim();
        const heroContentPaddingLeft = elementStyles.getPropertyValue('--hero-content-padding-left').trim();

        if (window.innerWidth >= 768) {
            topOffset = heroContentRect.height / 2;
            heroContentSliderNavi.style.right = `calc(${this.heroSlider.getBoundingClientRect().right}px - ${heroContentRect.right}px + ${heroContentPaddingRight})`;
            heroContentSliderNavi.style.removeProperty('width');
            heroContentSliderNavi.style.removeProperty('left');
        } else {
            topOffset = 28;
            heroContentSliderNavi.style.left = `calc(${heroContentRect.left}px + ${heroContentPaddingLeft})`;
            heroContentSliderNavi.style.width = `calc(${this.heroContent.offsetWidth}px - ${heroContentPaddingLeft} - ${heroContentPaddingRight})`;
            heroContentSliderNavi.style.removeProperty('right');
        }
        heroContentSliderNavi.style.top = `calc(${this.heroWrapper.offsetTop - topOffset}px + ${heroContentPaddingTop})`;
    }

    getTranslateY(element) {
        const style = getComputedStyle(element);
        const transform = style.transform;

        if (transform && transform.startsWith('matrix')) {
            const values = transform.match(/matrix\(([^)]+)\)/)[1].split(',').map(v => parseFloat(v.trim()));
            return values[5]; // translateY
        }

        return 0;
    }
}

export default HeroBanner;